<template>
  <v-flex>
    <v-row>
      <v-col cols="12" :sm="12" :md="6" :lg="6">
        <chart-card-container icon="" title="Salary and experience">
          <template slot="chart">
<!--            <v-sheet>-->
<!--              <v-row>-->
<!--                <v-col class="text-right">Employee role</v-col>-->
<!--                <v-col class="text-left"></v-col>-->
<!--              </v-row>-->
<!--            </v-sheet>-->
            <v-sheet class="text-center">
              <h3 class="light-blue--text display-3">{{getYearsInCurrentPosition}}</h3>
              <p>Years of experience as <strong>{{jobKeyword.name}}</strong> <edit-profile :profile-id="profile._id" :IdTarget="'job-search'"></edit-profile></p>
            </v-sheet>
            <v-sheet class="text-center">
              <v-row>
                <v-col>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="salaryRange === '-' && on">
                        <h3 class="light-blue--text display-1" >{{salaryRange}} &euro;</h3>
                        <p>Current salary range <edit-profile :profile-id="profile._id" :IdTarget="'salary'"></edit-profile></p>
                      </div>
                    </template>
                    You can edit the salary range to get more insights
                  </v-tooltip>
                </v-col>
                <v-col>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="salaryRange === '-' && on">
                        <h3 class="light-blue--text display-1">{{bonusRange}} &euro;</h3>
                        <p>Current bonus range <edit-profile :profile-id="profile._id" :IdTarget="'salary'"></edit-profile></p>
                      </div>
                    </template>
                    You can edit the bonus range to get more insights
                  </v-tooltip>
                </v-col>
              </v-row>
<!--              <h3 class="light-blue&#45;&#45;text display-3">{{getCurrentSalary && getCurrentSalary.baseSalaryRange.min}} - {{getCurrentSalary && getCurrentSalary.baseSalaryRange.max}}</h3>-->
<!--              <p>Current salary range</p>-->
            </v-sheet>
<!--            <v-sheet>-->
<!--              <h3 class="light-blue&#45;&#45;text display-3">{{bonusRange}}</h3>-->
<!--              <p>Current bonus range</p>-->
<!--            </v-sheet>-->
          </template>
        </chart-card-container>
      </v-col>
<!--      <v-col cols="12" :sm="12" :md="6" :lg="6">-->
<!--        <chart-card-container icon="mdi-map-marker" title="Main job locations">-->
<!--          <template slot="chart">-->
<!--            <job-offers-per-location-bubbles :jobOffers="jobOffers" :height="210" v-if="jobOffers"></job-offers-per-location-bubbles>-->
<!--          </template>-->
<!--        </chart-card-container>-->
<!--      </v-col>-->
      <v-col cols="12" :sm="12" :md="6" :lg="6">
        <chart-card-container icon="mdi-account-cash" title="Salaries">
          <template slot="chart">
            <salaries-line
              :job-keyword="jobKeyword"
              :current-salary="getCurrentSalary"
              :years-in-current-position="Math.round(getYearsInCurrentPosition)"
              :height="210"
              v-if="this.jobKeyword"></salaries-line>
          </template>
        </chart-card-container>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" :sm="12" :md="6" :lg="6">
        <chart-card-container icon="mdi-domain" title="Top 10 companies with active offers">
          <template slot="chart">
            <job-offers-per-company-bars :jobOffers="jobOffers" v-if="jobOffers"></job-offers-per-company-bars>
          </template>
        </chart-card-container>
        <!--        <chart-card-container icon="mdi-laptop" title="Top 10 job offer portals">-->
        <!--          <template slot="chart">-->
        <!--            <job-offers-per-portal-bars :jobOffers="jobOffers" v-if="jobOffers"></job-offers-per-portal-bars>-->
        <!--          </template>-->
        <!--        </chart-card-container>-->
      </v-col>

      <v-col cols="12" :sm="12" :md="6" :lg="6">
        <chart-card-container icon="mdi-briefcase-arrow-up-down-outline" title="Job offers metrics">
          <template #chart>
            <job-offers-counters :job-offers-counters="jobOffersCounters" />
          </template>
        </chart-card-container>
      </v-col>

      <v-col cols="12" :sm="12" :md="6" :lg="6">
        <chart-card-container icon="mdi-tag" title="Job offers last weeks">
          <template slot="chart">
            <job-offers-per-week-bars :histogram="jobOffersStats" v-if="jobOffersStats"></job-offers-per-week-bars>
          </template>
        </chart-card-container>
      </v-col>
    </v-row>

  </v-flex>
</template>

<script>

  import JobOffersPerWeekBars from "../Charts/Profile/jobOffersPerWeekBars";
  import JobOffersPerLocationBubbles from "../Charts/Profile/jobOffersPerLocationBubbles";
  import JobOffersPerPortalBars from "../Charts/Profile/jobOffersPerPortalBars";
  import JobOffersPerCompanyBars from "../Charts/Profile/jobOffersPerCompanyBars";
  import ChartCardContainer from "../Charts/chartCardContainer";
  import SalariesLine from "../Charts/Profile/salariesLine";
  import EditProfile from "../Buttons/Profiles/editProfile";
  import {formatRange} from "../../helpers/helpers";
  import JobOffersCounters from "../Charts/Profile/JobOffersCounters";

  export default {
    name: "profileJobOffers",
    components: {
      JobOffersCounters,
      EditProfile,
      SalariesLine,
      ChartCardContainer,
      JobOffersPerCompanyBars,
      JobOffersPerPortalBars,
      JobOffersPerLocationBubbles,
      JobOffersPerWeekBars
    },
    props: ['jobOffers', 'profile', 'jobKeyword', 'jobOffersCounters'],
    data() {
      return {
        selectedDates: [],
      }
    },
    computed: {
      jobOffersStats(){
        if (this.profile && this.profile.edges && this.profile.edges.jobs && this.profile.edges.jobs.stats){
          return this.profile.edges.jobs.stats.map(e => {
            let elem = {...e};
            if (elem.jobSearchTermsPerWeek && elem.jobSearchTermsPerWeek.length > 0) {
              elem.jobSearchTermsPerWeek = elem.jobSearchTermsPerWeek.slice(-15);
            } else if (elem.keywordsPerWeek && elem.keywordsPerWeek.length > 0) {
              elem.jobSearchTermsPerWeek = elem.keywordsPerWeek.slice(-15);
            }
            return elem;
          });
        }
        return null;
      },
      getCurrentSalary() {
        if (this.profile && this.profile.salary && this.profile.salary.length > 0) {
          let currentSalary = this.profile.salary.find(salary => salary.baseSalaryRange && (salary.baseSalaryRange.max > 0 || salary.baseSalaryRange.max === null) && salary.to === null);
          if (currentSalary){
            return currentSalary;
          }
        }
        return null;
      },
      getYearsInCurrentPosition() {
        if (this.profile && this.profile.edges && this.profile.edges.times && this.profile.edges.times.timeInCurrentPosition) {
          return Math.min(Math.ceil(this.profile.edges.times.timeInCurrentPosition / 12 * 10) / 10)
        }
        return null;
      },
      salaryRange() {
        if (this.getCurrentSalary && this.getCurrentSalary.baseSalaryRange &&
          (this.getCurrentSalary.baseSalaryRange.max > 0 || (this.getCurrentSalary.baseSalaryRange.max === null && this.getCurrentSalary.baseSalaryRange.min > 0))
        ) {
          return formatRange(this.getCurrentSalary.baseSalaryRange);
        }
        return '-';
      },
      bonusRange() {
        if (this.getCurrentSalary && this.getCurrentSalary.bonusSalaryRange &&
          (this.getCurrentSalary.bonusSalaryRange.max > 0 || (this.getCurrentSalary.bonusSalaryRange.max === null && this.getCurrentSalary.bonusSalaryRange.min > 0))
        ) {
          return formatRange(this.getCurrentSalary.bonusSalaryRange);
        }
        return '-';
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TabContents/profileJobOffers.vue